'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print product order terms
 */
    .directive('capOrderProductTerms', function () {
        return {
            restrict: 'A',
            transclude: true,
            scope: {
                subscriptionBookIsRunning: "=",
                subscriptionBookWorkflowWasInvoked: "=",
                invertColoring: "=",
                texts: "=",
                textLists: "=",
                hyperlinks: "=",
                actions: "=",
                confirmation: "=",
                obligationToPay: "=",
                subscriptionBookedByExtern: "=",
                canNotSucceed: "=",
                bookingAllowed: "=",
                formValid: "=",
                modeOptin: "=?"
            },
            controller: ["$scope", function($scope) {
                if ( $scope.invertColoring === true ) {
                    $scope.alternateBgColor2 = 'cap_order_section_odd';
                    $scope.alternateBgColor1 = 'cap_order_section_even';
                } else {
                    $scope.alternateBgColor1 = 'cap_order_section_odd';
                    $scope.alternateBgColor2 = 'cap_order_section_even';
                }
            }],
            templateUrl: "templates/orderproductterms.html"
        }
    });